// @flow
import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Popover from '@material-ui/core/Popover';
import Paper from '@material-ui/core/Paper';
import { translate } from 'react-i18next';

import Radio from 'common/domain/radio';
import User from 'common/domain/user';
import { openSnackbar } from 'common/modules/ui/actions/uiActions';
import RadioUser from 'statsradio/domain/RadioUser';

import { switchRadio } from '../../modules/authentication/session/actions/sessionActions';
import RadioListingItem from '../../modules/radio/components/RadioListingItem';
import { getRadioUser, getUser } from '../../modules/authentication/session/selectors/sessionSelectors';
import { getRadio } from '../../modules/authentication/session/reducers/sessionReducer';

const Wrapper = styled.a`
  width: 220px;
  height: 58px;
  margin: 10px;
  display: flex;
  align-items: center;
  border: solid 1px ${props => props.theme.V3.colors.form.border};
  border-radius: 2px;
  cursor: pointer;
`;

const LogoWrapper = styled.div`
  height: 42px;
  width: 42px;
  margin-left: 21px;
  position: relative;
  display: flex;
  align-items: center;
`;

const Logo = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const Text = styled.div`
  font-size: 17px;
  font-family: Lato;
  font-weight: bold;
  letter-spacing: 0.2px;
  margin-right: 24px;
  color: ${({ theme }) => theme.V3.colors.text.primary};
`;

const Icon = styled.i`
  color: ${({ theme }) => theme.V3.colors.text.primary};
`;

const CurrentRadioWrapper = styled.div`
  margin-left: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;


const RadioPopover = styled(Popover)`
  top: ${props => props.theme.V3.metrics.navbar.height}px;
  
  & > * {
    max-height: 100%;
  }
`;

const SPaper = styled(Paper)`
  width: ${props => props.theme.V3.metrics.menu.width}px;
`;

type Props = {
  radio: Radio,
  user: User,
  radioUser?: RadioUser,

  error: string,
  t: any,
  actions: {
    switchRadio: (radio: Object) => mixed,
    openSnackbar: (type: string, message: string) => mixed,
  },
};

type State = {
  displayRadios: boolean,
  anchor: React.Element<any> | Object,
};

class CurrentRadioHeader extends React.Component<Props, State> {
  state: State;

  constructor() {
    super();

    this.state = {
      displayRadios: false,
      anchor: {},
    };
  }

  onShowListing = (event) => {
    event.preventDefault();

    this.setState({
      displayRadios: true,
      anchor: event.currentTarget,
    });
  }

  onCloseListing = () => {
    this.setState({ displayRadios: false });
  }

  onRadioSelected = async (selectedRadio: Radio) => {
    const { t, radio } = this.props;
    this.onCloseListing();
    if (selectedRadio.is(radio.callSign)) {
      return;
    }

    await this.props.actions.switchRadio(selectedRadio);
    if (this.props.error) {
      this.props.actions.openSnackbar('error', t('errorWhileChangingStation'));
    }
  }

  render() {
    const { radio, radioUser, user } = this.props;
    if (!radio) {
      return null;
    }

    const { callSign, logo } = radio;
    const { radios } = user;

    return (
      <React.Fragment>
        <Wrapper onClick={this.onShowListing}>
          <LogoWrapper>
            <Logo src={logo} />
          </LogoWrapper>
          <CurrentRadioWrapper>
            <Text>{callSign}</Text>
            <Icon className="material-icons">arrow_drop_down</Icon>
          </CurrentRadioWrapper>
        </Wrapper>
        <RadioPopover
          open={this.state.displayRadios}
          onClose={this.onCloseListing}
          marginThreshold={0}
          PaperProps={{ component: SPaper }}
        >
          {radios.map(r => <RadioListingItem key={r.callSign} radio={r} user={radioUser} onSelectRadio={this.onRadioSelected} />)}
        </RadioPopover>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: getUser(state),
    radioUser: getRadioUser(state),
    radio: getRadio(state),
    error: state.session.error,
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ switchRadio, openSnackbar }, dispatch),
  };
}

export default translate('radio')(connect(mapStateToProps, mapDispatchToProps)(CurrentRadioHeader));



// WEBPACK FOOTER //
// ./src/statsradio/layout/v2/CurrentRadioHeader.js